import React from 'react';
import { rescueHtml } from '../components/Tools.js';
import Logo from '../Img/Logo_projets&finances.png';

const Page3Description_Operations = (props) => {
    const blue = '#069BD3';
    const green = '#59B44A';
    const greyChapter = '#DBDBDB';
    const greyclair = '#FAFAFA';
    const fontsize = (props.height*12/890);
    const rowHeight = (props.height*40/890);
    const largeRowHeight = (props.height*70/890);
    
    const FieldBoxLargeTop = ({label}) => (
        <div style={{backgroundColor: greyChapter, width: '30%', borderTopLeftRadius: 3, borderBottomLeftRadius: 3, textAlign: 'left', margin: '0 auto', display: 'flex', alignItems: 'center'}}>
            <p style={{marginTop: (0-props.marge), marginLeft: 5, fontSize: fontsize+2, lineHeight: 1.2}}>{label}</p>
        </div>
    );

    const ValueBoxLargeTop = ({value}) => (
        <div style={{backgroundColor: greyclair, width: '70%', borderTopRightRadius: 3, borderBottomRightRadius: 3, textAlign: 'left', display: 'flex', alignItems: 'center'}}>
            <p style={{marginTop: (15-props.marge), marginLeft: 5, fontSize: fontsize+2, lineHeight: 1.2, whiteSpace: 'normal', wordWrap: 'break-word', height: 60, overflowY: 'hidden'}}>{value || ''}</p>
        </div>
    );

    const FieldBox = ({label}) => (
        <div style={{height: rowHeight, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: greyChapter, width: '95%', borderTopLeftRadius: 3, borderBottomLeftRadius: 3}}>
            <p style={{marginTop: (0-props.marge), fontSize: fontsize+2, lineHeight: 1}}>{label}</p>
        </div>
    );

    const ValueBox = ({value}) => (
        <div style={{height: rowHeight, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: greyclair, width: '95%', borderTopRightRadius: 3, borderBottomRightRadius: 3}}>
            <p style={{marginTop: (0-props.marge), fontSize: fontsize+2}}>{value || ''}</p>
        </div>
    );

    return (
        <div style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column', backgroundColor: 'white'}}>
            
            {/* Header */}
            <div style={{ display: 'flex', height: '20%' }}>
                <div style={{ flex: 0.6, display: 'flex', marginLeft: 10 }}>
                    {props.logo && (
                        <img style={{ maxHeight: props.height / 8, borderRadius: 5 }} src={props.logo} alt="Logo" />
                    )}
                </div>

                <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <p style={{ color: blue, fontSize: (fontsize + 10) }}>Description de l'opération</p>
                </div>

                <div style={{ flex: 0.6, display: 'flex', justifyContent: 'right', marginRight: 25 }}>
                    <p style={{ color: 'grey', fontSize: (fontsize + 4) }}>{props.operation.nom}</p>
                </div>
            </div>

            {/* Contenu - 60% */}
            <div style={{flex: 1, padding: '10px 15px', display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                
                {/* Ligne 1: Description */}
                <div style={{display: 'flex', marginBottom: fontsize, height: largeRowHeight}}>
                    <FieldBoxLargeTop label="Description" />
                    <ValueBoxLargeTop value={rescueHtml(props.operation.description || '')} />
                </div>

                {/* Ligne 2: Enjeu */}
                <div style={{display: 'flex', marginBottom: fontsize, height: largeRowHeight}}>
                    <FieldBoxLargeTop label="Enjeu" />
                    <ValueBoxLargeTop value={rescueHtml(props.operation.enjeu || '')} />
                </div>

                {/* Ligne 3: Prérequis */}
                <div style={{display: 'flex', marginBottom: fontsize, height: largeRowHeight}}>
                    <FieldBoxLargeTop label="Prérequis de mise en œuvre" />
                    <ValueBoxLargeTop value={rescueHtml(props.operation.prerequis_mise_en_oeuvre || '')} />
                </div>

                {/* Ligne 4: Questions/Remarques */}
                <div style={{display: 'flex', marginBottom: fontsize+25, height: largeRowHeight}}>
                    <FieldBoxLargeTop label="Questions / Remarques" />
                    <ValueBoxLargeTop value={rescueHtml(props.operation.questions || '')} />
                </div>

                {/* Ligne 5 & 6: Gestionnaire et Service referent */}
                <div style={{display: 'flex', marginBottom: fontsize}}>
                    <div style={{flex: 1, display: 'flex', flexDirection: 'column'}}>
                        <FieldBox label="Gestionnaire interne" />
                        <ValueBox value={rescueHtml(props.operation.gestionnaire_interne || '')} />
                    </div>
                    <div style={{flex: 1, display: 'flex', flexDirection: 'column'}}>
                        <FieldBox label="Service referent" />
                        <ValueBox value={rescueHtml(props.operation.service_referent || '')} />
                    </div>
                </div>

                {/* Ligne 7: Technicien referent (nom, email, telephone) */}
                <div style={{display: 'flex', marginBottom: fontsize}}>
                    <div style={{flex: 1, display: 'flex', flexDirection: 'column'}}>
                        <FieldBox label="Technicien référent - Nom" />
                        <ValueBox value={rescueHtml(props.operation.technicien_nom || '')} />
                    </div>
                    <div style={{flex: 1, display: 'flex', flexDirection: 'column'}}>
                        <FieldBox label="Technicien référent - Email" />
                        <ValueBox value={rescueHtml(props.operation.technicien_mail || '')} />
                    </div>
                    <div style={{flex: 1, display: 'flex', flexDirection: 'column'}}>
                        <FieldBox label="Technicien référent - Téléphone" />
                        <ValueBox value={rescueHtml(props.operation.technicien_telephone || '')} />
                    </div>
                </div>

                {/* Ligne 8: Fonction technicien */}
                <div style={{display: 'flex', marginBottom: fontsize}}>
                    <div style={{flex: 0.5}}></div>
                    <div style={{flex: 1, display: 'flex', flexDirection: 'column'}}>
                        <FieldBox label="Fonction technicien référent" />
                        <ValueBox value={rescueHtml(props.operation.technicien_fonction || '')} />
                    </div>
                    <div style={{flex: 0.5}}></div>
                </div>

            </div>

            {/* Footer - 20% */}
            <div style={{padding: '5px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', zIndex: 1}}>
                <div>
                    <p style={{fontSize: fontsize, color: '#666'}}>
                        {props.date}
                    </p>
                </div>
                <p style={{fontSize: fontsize, color: '#8B8B8B'}}>page : {props.pagination} / {props.countPageTotal}</p>
                <div>
                    <img style={{objectFit: 'contain', height: 40, borderRadius: 6}} src={Logo} alt="Logo SF" />
                </div>
            </div>
        </div>
    );
};

export default Page3Description_Operations;
